import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Check } from "lucide-react";
import CompleteOrderDialog from "./CompleteOrderDialog";
import { useState } from "react";
import { User } from "@/interface/entityInterface";

const CompleteOrderItem = ({selectedRows}: {selectedRows: {original: User}[]}) => {
  const [open, setOpen] = useState(false)

  return (
    <div className="relative z-50" key="order">
      <DropdownMenuItem onClick={(e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        setOpen(true)
      }} key="complete-order">
        <Check />
        complete order
      </DropdownMenuItem>
      <CompleteOrderDialog open={open} setOpen={setOpen} selectedIds={selectedRows?.map(driver => driver.original.drivers[0].id)} />
    </div>
  )
};

export default CompleteOrderItem;
